import * as echarts from 'echarts/core';
import {BarChart, LineChart, PieChart, SankeyChart, SunburstChart, TreemapChart} from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    TooltipComponent,
    ToolboxComponent,
    DataZoomComponent,
} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';

echarts.use([
    BarChart,
    LineChart,
    PieChart,
    SunburstChart,
    TreemapChart,
    SankeyChart,
    GridComponent,
    LegendComponent,
    TooltipComponent,
    ToolboxComponent,
    DataZoomComponent,
    CanvasRenderer,
]);

export default echarts;
